import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import { IonApp, IonRouterOutlet, toastController, useBackButton, useIonRouter, UseIonRouterResult, IonLoading  } from '@ionic/vue';
import { onBeforeMount, ref } from 'vue';
import { App } from '@capacitor/app';
import { Network } from '@capacitor/network'
import { StatusBar, Style } from '@capacitor/status-bar'
import { Device, DeviceInfo } from '@capacitor/device'
import { setAppData } from './functions/setAppData'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const ionRouter: UseIonRouterResult = useIonRouter();
const route = useRoute()

const dataIsLoaded = ref(false)

useBackButton(10, (processNextHandler) => {
  if (ionRouter.canGoBack()) {
    //ionRouter.navigate('/home', 'back', 'pop')
  } 
  processNextHandler()
});
useBackButton(-1, () => {
  if (!ionRouter.canGoBack()) {
    App.exitApp();
  } 
});

Device.getInfo().then((res: DeviceInfo) => {
  if(res.platform !== 'web') {
    StatusBar.setStyle({ style: Style.Light })
    StatusBar.setBackgroundColor({ color: '#FFFFFF' })
  }
})

onBeforeMount(async() => {
  if((await Network.getStatus()).connected === false) {
    const toast = await toastController.create({
      message: 'Keine Internetverbindung',
      duration: 4000,
      cssClass: 'toast'
    })
    await toast.present()
  } 
  if(route.path !== '/login')
    await setData()
  else 
    dataIsLoaded.value = true
})

async function setData() {
  try {
    await setAppData()
  } finally {
    dataIsLoaded.value = true
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      (dataIsLoaded.value)
        ? (_openBlock(), _createBlock(_unref(IonRouterOutlet), { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_unref(IonLoading), {
        "is-open": !dataIsLoaded.value,
        message: "Lade Daten..."
      }, null, 8, ["is-open"])
    ]),
    _: 1
  }))
}
}

})